export default "__VITE_ASSET__DL_WFRho__"